import Logout from '../Logout/logout';
import {
  Dashboard,
  BuyingMoments,
  CustomerSegments,
  Offers,
  CreateOffer,
  Settings,
  LandingPages,
  OfferDescription,
  Marketplace,
  MarketplaceDescription,
  Perks,
  AncillaryAPIDetails,
} from './loadable';
import {
  ANCILLARY_API,
  BUYING_MOMENT, CAMPAIGN_DESCRIPTION, CAMPAIGNS,
  CREATE_CAMPAIGN,
  CUSTOMER_SEGMENT,
  DASHBOARD, LOGOUT,
  MARKETPLACE, OFFER_DESCRIPTION, OFFERS,
  PERKS, SETTINGS
} from '../../common/i18n';

export const PRIVATE_ROUTES_ARM = [
  { header: 'Dashboard', path: '/dashboard', component: Dashboard, label: DASHBOARD },
  { header: 'Buying Moments', path: '/buying-moments', component: BuyingMoments, label: BUYING_MOMENT },
  { header: 'Marketplace', path: '/marketplace', component: Marketplace, label: MARKETPLACE },
  { header: 'All Customer Segments', path: '/customer-segments', component: CustomerSegments, label: CUSTOMER_SEGMENT },
  { header: 'Create Campaign', path: '/offers/create-offer', component: CreateOffer, label: CREATE_CAMPAIGN },
  { header: 'Campaign Description', path: '/offers/:offerid', component: OfferDescription,
    label: CAMPAIGN_DESCRIPTION },
  { header: 'Offer Description', path: '/marketplace/:offerid', component: MarketplaceDescription,
    label: OFFER_DESCRIPTION },
  { header: 'All Campaigns', path: '/offers', component: Offers, label: CAMPAIGNS },
  { header: 'Offers', path: '/landing-pages', component: LandingPages, label: OFFERS },
  { header: 'Perks', path: '/perks', component: Perks, label: PERKS },
  { header: 'Ancillary API', path: '/ancillary-api-details', component: AncillaryAPIDetails, label: ANCILLARY_API },
  { header: 'Settings', path: '/settings', component: Settings, label: SETTINGS },
  { header: '', path: '/logout', component: Logout, label: LOGOUT },
];

export const PRIVATE_ROUTES_PRM = [
  { header: 'All Offers', path: '/offers', component: Offers, icon: '', label: OFFERS },
  { header: 'Create Offer', path: '/offers/create-offer', component: CreateOffer, label: CREATE_CAMPAIGN },
  { header: 'Offer Description', path: '/offers/:offerid', component: OfferDescription, label: CAMPAIGN_DESCRIPTION },
  { header: 'Performance', path: '/performance', component: Dashboard, icon: '', label: DASHBOARD },
  { header: 'Perks', path: '/perks', component: Perks, label: PERKS },
  { header: 'Settings', path: '/settings', component: Settings, label: SETTINGS },
  { header: '', path: '/logout', component: Logout, label: LOGOUT },
];
